import { EmailAttachedTag } from '../../EmailAttachedTag'

import * as styles from './EmailThreadPreviewList.module.css'

function EmailThreadPreviewList({
  Item = EmailAttachedTag,
  className = styles.EmailThreadPreviewList,
  disabled,
  items,
  onDelete,
}) {
  return (
    <div className={className}>
      {items?.map(item => (
        <Item
          disabled={disabled}
          item={item}
          key={item.uuid}
          onDelete={onDelete}
        />
      ))}
    </div>
  )
}

export default EmailThreadPreviewList
